import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Button, Label, Loader } from '@atlas/ui';

import useExpirationCountdown from './useExpirationCountdown';

const ExpirationCountdownTimer = ({
  expirationCountdown,
  expiredAt,
  isLoading,
  onExpire,
  onGenerateNewCode,
}) => {
  const { isExpired, timeDisplay, timerProgress } = useExpirationCountdown({
    expirationCountdown,
    expiredAt,
    onExpire,
  });

  const barFillStyle = { width: `${Math.round(timerProgress * 100)}%` };
  const className = cx('expiration-countdown-timer', {
    'expiration-countdown-timer-expired': isExpired,
  });

  return (
    <div className={className}>
      {isExpired ? (
        <>
          <Label
            className="expiration-countdown-timer__expired-text"
            message="payment_session_expired"
          />
          <Button
            className="expiration-countdown-timer__generate-btn"
            disabled={isLoading}
            onClick={onGenerateNewCode}
          >
            <Label message="generate_new_code" />
          </Button>
        </>
      ) : (
        <>
          <div className="expiration-countdown-timer__header">
            <Label className="expiration-countdown-timer__label" message="time_left" />
            <span className="expiration-countdown-timer__time">{timeDisplay}</span>
          </div>
          <div className="expiration-countdown-timer__bar">
            <div className="expiration-countdown-timer__bar-fill" style={barFillStyle} />
          </div>
          <div className="expiration-countdown-timer__status">
            <Loader className="expiration-countdown-timer__status-icon" />
            <Label
              className="expiration-countdown-timer__status-text"
              message="waiting_for_payment"
            />
          </div>
        </>
      )}
    </div>
  );
};

ExpirationCountdownTimer.propTypes = {
  expirationCountdown: PropTypes.number.isRequired,
  expiredAt: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
  onExpire: PropTypes.func.isRequired,
  onGenerateNewCode: PropTypes.func.isRequired,
};

export default ExpirationCountdownTimer;
